module.exports = __webpack_public_path__ + "static/thumb-menu-tiempos-4f2def1d1dc24f54bc337a1b986d7712.jpg";